import { QueryKeysConfig } from "@/config/query-keys";
import { setClientTimezone } from "@/persistence/timezone";
import { useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";

export const useServerTimezone = () => {
  const queryClient = useQueryClient();
  return queryClient.getQueryData<string>([QueryKeysConfig.serverTimezone])!;
};
export const useClientTimezone = () => {
  const queryClient = useQueryClient();
  return queryClient.getQueryData<string | undefined>([
    QueryKeysConfig.clientTimezone,
  ]);
};
export const useChangeClientTimezone = () => {
  return (timezone: string) => {
    setClientTimezone(timezone);
  };
};

export const useRevealTimezoneToServer = () => {
  const queryClient = useQueryClient();
  const changeClientTimezone = useChangeClientTimezone();
  useEffect(() => {
    const clientTimezone = queryClient.getQueryData<string>([
      QueryKeysConfig.clientTimezone,
    ])!;
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (clientTimezone !== timezone) {
      changeClientTimezone(timezone);
    }
  }, [queryClient, changeClientTimezone]);
};
